import React from 'react'; //eslint-disable-line
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import Detail from '../components/Detail';
import * as CONSTS from '../utils/constants';
import '../i18n';
import { useLocation } from 'react-router-dom';


const UnionTripDetail = observer(props => {
  const { t } = useTranslation();
  const location = useLocation();

  const _headerCol = [
    t('unionTripDetail.columnHeadings.1'),
    t('unionTripDetail.columnHeadings.2'),
    t('unionTripDetail.columnHeadings.3'),
    t('unionTripDetail.columnHeadings.4')
  ];

  return (
    <Detail
      direction={CONSTS.SERVICE_DIRECTION_OUTBOUND}
      headerCol={_headerCol}
      departureClass="union"
      params={props.params}
      coachCount={location.state ? location.state.coachCount : null}
      scheduledCoachCount={location.state ? location.state.scheduledCoachCount : null}
    />
  );
});

export default UnionTripDetail;
